<div class="m-box w33" style="margin: 1em;" [formGroup]="gs.gastroForm">
    <h2 matTooltip="Double Click To Reset" style="cursor: pointer;"
        (dblclick)="gs.gastroForm.get(item.db)!.setValue(-1);gs.gastroForm.get(item.db+'Comment')!.setValue(null)">{{item.name}}</h2>
    <div class="anatomy-twin-radios" style="margin-block-start: 0.3em;"
        (dblclick)="gs.gastroForm.get(item.db)!.setValue(-1);gs.gastroForm.get(item.db+'Comment')!.setValue(null)">

        <label class="observe">

            <input type="radio" class="custom-check customInput"
                [formControlName]="item.db" [name]="item.db" [value]="0"/>
            <i class="customInput-display"></i>
            <span>
                Normal
            </span>
        </label>
        <label class="not-observe">

            <input type="radio" [formControlName]="item.db" [name]="item.db"
                class="custom-check customInput" [value]="1"/>
            <i class="customInput-display"></i>
            <span>
                Abnormal
            </span>

        </label>
    </div>
    <div class="commDiv">
        <label>Comments</label>
        <textarea class="fulltext" style="height: 100%;margin-block-start: 1em;border: revert;"
            [formControlName]="item.db+'Comment'"></textarea>
        <button class="t-btn-edit" *ngIf="! es.isClosed"
            (click)="atS.showAuto(gs.gastroForm.get(item.db+'Comment')!,item.name +' Comments',132+id)">Auto Text</button>
    </div>
</div>
